<template>
  <div :class="padding">
    <v-row justify="center" align="center" :class="margin">
      <v-col cols="12" class="text-center" :class="margin">
        <v-img 
          class="mx-auto"
          contain
          alt="vuetify"
          :width="size"
          :height="size"
          :src="require('@/assets/image/empty.png')">
          <template v-slot:placeholder>
            <v-row
              class="fill-height"
              align="center"
              justify="center">
              <v-progress-circular 
                indeterminate 
                color="#388E3C">
              </v-progress-circular>
            </v-row>
          </template>
        </v-img>

        <p 
          class="font-weight-light text-second my-6"
          :class="font">
          Belum ada data <b>{{ message }}</b>!!!
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    props: {
      margin: {
        type: String,
        default: 'my-16'
      },
      padding: {
        type: String,
        default: 'pa-16'
      },
      font: {
        type: String,
        default: 'title'
      },
      size: {
        type: Number,
        default: 150
      },
      message: {
        type: String,
        default: ''
      }
    }
  }
</script>